import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import Notification from './Notification';
const useStyles = makeStyles(_ref => {
  let {
    palette
  } = _ref;
  return {
    root: {
      position: 'sticky'
    },
    variantSuccess: {
      backgroundColor: palette.success.main
    },
    variantError: {
      backgroundColor: palette.error.main
    },
    variantInfo: {
      backgroundColor: palette.info.main
    },
    variantWarning: {
      backgroundColor: palette.warning.main
    }
  };
});
const Snackbar = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const theme = useTheme();
  const classes = useStyles(theme);
  return /*#__PURE__*/React.createElement(SnackbarProvider, _extends({
    classes: classes
  }, props), children, /*#__PURE__*/React.createElement(Notification, null));
};
export default Snackbar;